import { Buffer } from "buffer";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { WagmiProvider } from "wagmi";
import App from "App";

// Reown AppKit must be initialised once before any wallet UI is rendered.
// Importing the config module runs `createAppKit` and exposes the wagmi config.
import { wagmiConfig } from "./config/appkit";

import "./app/i18n/i18n";
import "./app/globals.css";

import reportWebVitals from "./reportWebVitals";

// Browser polyfills required by the WalletConnect / AppKit stack.
if (typeof window !== "undefined") {
  (window as unknown as { global?: unknown }).global ??= window;
  (window as unknown as { Buffer?: unknown }).Buffer ??= Buffer;
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <WagmiProvider config={wagmiConfig}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </WagmiProvider>
);

reportWebVitals();
